import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import * as yup from 'yup';

import { Scenes } from '../../../../types/items';
import {
  ReactFormInput,
  ReactFormModal,
} from '../../../../components';
import { useActionDispatcher } from '../../../../hooks';
import { selectListScenes, selectCurrentSceneId } from '../../../../store/modules/scenes/selectors';
import { duplicateScenesRequest } from '../../../../store/modules/scenes/actions';
import useStyles from '../styles';
import Action from '../../../../components/action/Action';
import { CopyIcon } from '../../../../components/icon/regular';

const sceneSchema = yup.object().shape({
  title: yup.string().required().trim(),
});


const DuplicateScriptAction = () => {
  const classes = useStyles();
  const scenesList = useSelector(selectListScenes);
  const { id: projectId } = useParams<{id: string}>();
  const [isOpenForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState<Scenes>();
  const createScene = useActionDispatcher(duplicateScenesRequest);
  const currentSceneId = useSelector(selectCurrentSceneId);

  const currentScript = useMemo(() => {
    if (scenesList.data && scenesList.data.items.length > 0) {
      return scenesList.data.items.find((item) => item.id === currentSceneId);
    }
    return null;
  }, [scenesList.data, currentSceneId]);

  const addScriptHandler = useCallback(() => {
    const currentProjectId = parseInt(projectId, 10);

    if (currentProjectId && currentScript) {
      const data = { ...currentScript };
      data.title = `${currentScript.title} - copy`;
      setFormData(data);
      setOpenForm(true);
    }
  }, [projectId, setFormData, setOpenForm, currentScript]);

  return (
    <>
      <Action
        icon={<CopyIcon className={classes.icon} style={{ fontSize: '1rem' }} />}
        title="Duplicate"
        onClick={addScriptHandler}
      />
      <ReactFormModal
        open={isOpenForm}
        title="Duplicate Script"
        component={(
          <>
            <ReactFormInput autoFocus name="title" label="Title" />
          </>
        )}
        onCloseHandler={() => setOpenForm(false)}
        form={{
          data: formData,
          validationSchema: sceneSchema,
          onSubmit: createScene,
          creatingMode: true,
        }}
      />
    </ >
  );
};

export default DuplicateScriptAction;
